import capitalize from "lodash/capitalize";
import isEmpty from "lodash/isEmpty";
import trim from "lodash/trim";

import type { NodeId, Type } from "~/models/dto";

export class Messages {
	static successMerge(isUpdate: boolean, node: string) {
		return isUpdate ? Messages.successUpdate(node) : Messages.successCreate(node);
	}

	static successCreate(node: string) {
		return `${capitalize(node)} created.`;
	}

	static successUpdate(node: string) {
		return `${capitalize(node)} updated.`;
	}

	static successDelete(node: string) {
		return `${capitalize(node)} deleted.`;
	}

	static errorDelete(node: string) {
		return `Error, ${capitalize(node)} was not deleted.`;
	}

	static errorGet(type: string, id: NodeId) {
		return `Error, ${capitalize(type)} with id "${id}" was not loaded`;
	}

	static errorGetAll(type: Type) {
		return `Error, ${capitalize(type)} list was not loaded`;
	}

	static deleteConfirm(node: string) {
		return `Are you sure you want to permanently delete ${node}? This action cannot be undone.`;
	}

	static saveConfirmation(node: string) {
		return `Are you sure you want to save ${node}?`;
	}

	static resetSynchronizationConfirm(node: string) {
		return `Are you sure you want to reset ${node}?`;
	}

	static nodeTypeName(_type: string) {
		if (isEmpty(_type)) {
			return "";
		}
		// camel case to normal case
		return trim(_type.replace(/([A-Z])/gu, " $1").toLowerCase());
	}

	static errorStartingStackState() {
		return "There was a problem while starting the app. Please try again.";
	}

	static genericStreamError() {
		return "We had an error. This might be caused due to a very big view or a bad connection.";
	}

	static lockedNode(_type: string) {
		return `This ${Messages.nodeTypeName(_type)} is locked because it was created by a StackPack`;
	}

	static exportNodeFailed() {
		return "Export Node Failed. Try again later";
	}
}
